import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/chat/projects/chat/chatId/page';

export const Route = createFileRoute('/_app/_chat/projects/$projectId/chat/$chatId/')({
  component: Page,
});
